<template>
  <!-- 自定义智能助手弹窗， @click.self="closeDialog" -->
  <div v-if="localVisible" class="consult-overlay">
    <div class="consult-dialog" ref="dialogContainer">
      <div class="dialog-header">
        <div class="dialog-title">
          <i class="el-icon-service"></i>
          <span>智能助手</span>
        </div>
        <span class="dialog-close" @click="closeDialog">×</span>
      </div>

      <div class="consult-content" @click="handleContentClick">
        <div class="message-list" ref="messageList" @scroll="handleScroll">
          <!-- 加载更多提示 -->
          <div v-if="loadingMore" class="loading-more">
            加载中...
          </div>
          <div
            v-for="(msg, index) in messages"
            :key="index"
            :class="['message-item', msg.type]"
          >
            <div class="message-header">
                <div class="message-sender">{{ msg.sender == 1 ? '我' : '智能助手' }}</div>
                <div class="message-time">{{ msg.time }}</div>
            </div>
            <div :class="{'message-bubble':msg.msgType != 3}">
              <!-- 图片消息 -->
              <template v-if="msg.msgType === 2">
                <img
                  class="message-image"
                  :src="msg.content"
                  alt="图片消息"
                />
              </template>

              <!-- 文件消息 -->
              <template v-else-if="msg.msgType === 3">
                <div class="file-card">
                  <div class="file-card-main">
                    <div class="file-name">
                      {{ msg.content.name || '文件' }}
                    </div>
                    <div class="file-size" v-if="msg.content.size">
                      {{ formatFileSize(msg.content.size) }}
                    </div>
                  </div>
                  <div class="file-card-footer">
                    <span class="file-status">上传成功</span>
                  </div>
                </div>
              </template>

              <!-- 文本消息 / 兼容旧数据 -->
              <template v-else>
                <div class="message-text" v-html="parseMarkdown(msg.content)"></div>
              </template>
            </div>
          </div>
          <!-- 等待回复动画 -->
          <div v-if="waitingForReply" class="message-item received">
            <div class="message-header">
              <div class="message-sender">智能助手</div>
            </div>
            <div class="message-bubble typing-indicator">
              <span class="typing-dot"></span>
              <span class="typing-dot"></span>
              <span class="typing-dot"></span>
            </div>
          </div>
        </div>
        <div class="input-area" @click.stop>
          <div class="input-toolbar">
            <button class="toolbar-btn" @click="toggleEmojiPicker" title="表情">
               <svg class="icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" p-id="6568" width="20" height="20"><path d="M511.488 118.670222a398.222222 398.222222 0 1 0 0 796.444445 398.222222 398.222222 0 0 0 0-796.444445z m0-85.333333a483.555556 483.555556 0 1 1 0 967.111111 483.555556 483.555556 0 0 1 0-967.111111zM292.067556 378.709333a69.063111 69.063111 0 1 1 138.126222 0 69.063111 69.063111 0 0 1-138.126222 0z m300.657777 0a69.063111 69.063111 0 1 1 138.183111 0 69.063111 69.063111 0 0 1-138.183111 0zM275.626667 545.336889h475.249777c0 108.828444-100.067556 239.502222-240.355555 239.502222-140.231111 0-234.894222-130.673778-234.894222-239.502222z" fill="#333333" p-id="6569"></path></svg>
            </button>
            <!-- <button class="toolbar-btn" @click="triggerFileInput" title="文件" :disabled="true">
               <svg class="icon" viewBox="0 0 1024 1024" version="1.1"  fill="#242424" xmlns="http://www.w3.org/2000/svg" width="20" height="20"><path d="M191.4 765.1c0 22.6 18.3 41 41 41h158.1c22.6 0 41-18.3 41-41 0-22.6-18.3-41-41-41H232.3c-22.6 0-40.9 18.3-40.9 41zM889.3 855.1h-40.9 16.2c13.8-0.8 24.7-12.2 24.7-26.2v26.2zM141.3 855.2h40.9H166c-13.8-0.8-24.7-12.2-24.7-26.2v26.2zM889.3 549.6h-40.9 16.2c13.8 0.8 24.7 12.2 24.7 26.2v-26.2zM809.6 346.9h-40.9 16.2c13.8 0.8 24.7 12.2 24.7 26.2v-26.2zM141.6 244h40.9-16.2c-13.8 0.8-24.7 12.2-24.7 26.2V244z" fill="#242424" p-id="14631"></path><path d="M906.1 468.1H232.3c-22.6 0-41 18.3-41 41 0 22.6 18.3 41 41 41h657v305.1h-748V244.1h287.3l52.7 81.4a40.98 40.98 0 0 0 36.1 21.5h291.9v63.4c0 22.6 18.3 41 41 41s41-18.3 41-41v-83.2c-3.2-34.7-32.3-61.8-67.8-61.8H769v-0.2H539.9L486 181.9l-0.6-0.9c-7.3-11.3-20-18.9-34.5-18.9H182.3v0.1h-54.5c-37.6 0-68.1 30.5-68.1 68.1v0.5h-0.1v643.6c2.4 32.8 28 59.1 60.5 62.6h787c33.1-1.5 60-26.6 64.3-58.9V529.7c-3.3-33.7-31.1-60.3-65.3-61.6z"></path></svg>
            </button> -->
            <input
              ref="fileInput"
              type="file"
              style="display: none"
              @change="handleFileSelect"
              multiple
            />
          </div>
          <div v-if="showEmojiPicker" class="emoji-picker-container" @click.stop>
            <div class="emoji-picker">
              <div
                v-for="(emoji, index) in emojiList"
                :key="index"
                class="emoji-item"
                @click="insertEmoji(emoji)"
              >
                {{ emoji }}
              </div>
            </div>
          </div>
          <el-input
            v-model="inputMessage"
            type="textarea"
            :rows="3"
            placeholder="请输入文字"
            @keydown.enter.native.prevent="handleEnter"
            @paste.native="handlePaste"
          />
          <div class="input-footer">
            <span class="tip">按 Enter 发送，Shift+Enter 换行</span>
            <button
              class="send-btn"
              @click="sendMessage"
              :disabled="!inputMessage.trim()"
            >
              发送
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import websocketMixin from '@/websocket.js'
import {request2} from '@/utils/utils'
import { marked } from 'marked'

export default {
  name: 'OnlineConsultDialog',
  mixins: [websocketMixin],
  props: {
    // 父组件使用 :visible.sync 控制弹窗开关
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localVisible: this.visible,
      inputMessage: '',
      messages: [],
      isWebSocketConnected: false,
      showEmojiPicker: false,
      // 发送者ID（临时会话ID）
      tempId: localStorage.getItem('tempId') || '',
      emojiList: ['😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇', '🙂', '🙃', '😉', '😌', '😍', '🥰', '😘', '😗', '😙', '😚', '😋', '😛', '😝', '😜', '🤪', '🤨', '🧐', '🤓', '😎', '🤩', '🥳', '😏', '😒', '😞', '😔', '😟', '😕', '🙁', '☹️', '😣', '😖', '😫', '😩', '🥺', '😢', '😭', '😤', '😠', '😡', '🤬', '🤯', '😳', '🥵', '🥶', '😱', '😨', '😰', '😥', '😓', '🤗', '🤔', '🤭', '🤫', '🤥', '😶', '😐', '😑', '😬', '🙄', '😯', '😦', '😧', '😮', '😲', '🥱', '😴', '🤤', '😪', '😵', '🤐', '🥴', '🤢', '🤮', '🤧', '😷', '🤒', '🤕', '🤑', '🤠', '😈', '👿', '👹', '👺', '🤡', '💩', '👻', '💀', '☠️', '👽', '👾', '🤖', '🎃', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '😿', '😾'],
      // 流式消息缓存：key 为 msgId，value 为 { chunks: Map<seq, content>, metadata: {...} }
      streamingMessages: new Map(),
      // 无限滚动相关
      loadingMore: false, // 是否正在加载更多
      hasMore: true, // 是否还有更多消息
      // 等待回复状态
      waitingForReply: false // 是否正在等待客服回复
    }
  },
  watch: {
    visible(val) {
      this.localVisible = val
      if (val) {
        this.handleDialogOpen()
      } else {
        this.handleDialogClose()
      }
    },
    localVisible(val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    handleEnter(event) {
      if (event.shiftKey) {
        this.inputMessage += '\n'
      } else {
        this.sendMessage()
      }
    },
    // 关闭弹窗
    closeDialog() {
      this.localVisible = false
    },
    // 弹窗打开时的处理
    async handleDialogOpen() {
      // 确保 tempId 已设置
      if (!this.tempId) {
        this.tempId = localStorage.getItem('tempId') || ''
        if (!this.tempId) {
          this.tempId = this.uuidv4()
          localStorage.setItem('tempId', this.tempId)
        }
      }

      // 如果还没有建立连接，则建立连接
      if (!this.isWebSocketConnected && !this.globalData.webSocketLink) {
        // 使用 request2 获取 handshake 信息
        // debugger
        try {
          const handshakeData = await request2('get', '/chat/handshake', {});
          if (handshakeData && handshakeData.nonce && handshakeData.expire) {
            const {nonce, expire} = handshakeData;
            const sign = await this.hmacSign(this.tempId + nonce + expire, 'Turingene');
            this.linkSocket(this.tempId, nonce, expire, sign)
            this.isWebSocketConnected = true
          } else {
            throw new Error('handshake 返回数据格式不正确')
          }
        } catch (error) {
          console.error('获取 handshake 失败，使用 fetch 降级:', error);
        }

        // 设置消息回调
        this.globalData.callback = (res) => {
          try {
            const result = JSON.parse(res.data)
            console.log('接收消息',result)
            
            if (result.event !== 'CONNECT' && result.event !== 'HEART_BEAT') {
              // 处理新格式的 TALK 消息
              if (result.event === 'TALK' && result.content) {
                const content = result.content
                
                // 判断 sender：1-用户，2-系统，3-客服
                // 如果是用户发的消息（sender === 1），跳过 addMessage（发送时已经 addMessage 了）
                if (content.sender === 1) {
                  return
                }
                
                // 处理流式消息
                if (result.stream === true) {
                  this.handleStreamingMessage(result)
                  return
                }
                
                // 非流式消息，按原逻辑处理
                // 根据消息类型处理内容
                let messageContent = content.content
                
                if (content.msgType === 3) {
                  // 文件消息：content 可能是对象或 JSON 字符串，统一转换为对象
                  if (typeof messageContent === 'string' && messageContent.startsWith('{')) {
                    // content 是 JSON 字符串，需要解析
                    try {
                      messageContent = JSON.parse(messageContent)
                    } catch (e) {
                      console.error('解析文件消息失败:', e)
                    }
                  }
                  // 如果已经是对象，直接使用
                }
                
                this.addMessage(
                  {
                    sender: content.sender,
                    msgType: content.msgType,
                    content: messageContent, // 保持原始格式（对象或字符串）
                    createTime: content.createTime,
                    msgId: content.msgId // 保存 msgId
                  },
                  'received'
                )
                
                // 收到客服或系统回复，清除等待状态
                if (content.sender === 2 || content.sender === 3) {
                  this.waitingForReply = false
                }
              }
            }
          } catch (e) {
            console.error('解析消息失败:', e)
          }
        }
      }

      // 重置加载状态
      this.hasMore = true
      this.loadingMore = false
      
      // 获取消息列表
      await this.loadMessageList()
    },
    // 获取消息列表
    async loadMessageList() {
      try {
        // 首次加载，msgId 为空字符串，获取最新的 size 条消息
        const response = await request2('post', '/chat/getMessageList', {
          tempId: this.tempId,
          msgId: '',
          size: 10 // 获取50条消息
        })
        
        if (response && Array.isArray(response) && response.length > 0) {
          // 清空当前消息列表
          this.messages = []
          
          // 将服务器返回的消息转换为组件需要的格式
          response.forEach((msg) => {
            if (!msg) return
            
            const messageType = msg.sender === 1 ? 'sent' : 'received'
            let messageContent = msg.content || ''
            
            // 处理文件消息
            if (msg.msgType === 3) {
              let info = msg.info || ''
              if (typeof info === 'string' && info.startsWith('{')) {
                try {
                  info = JSON.parse(info)
                  info.url = msg.content
                } catch (e) {
                  console.error('解析文件消息失败:', e)
                }
              }
              messageContent = info
            }
            
            this.messages.push({
              type: messageType,
              msgType: msg.msgType || 1,
              content: messageContent,
              sender: msg.sender || 1,
              time: msg.createTime,
              msgId: msg.msgId // 保存 msgId 用于加载更多
            })
          })
          
          // 如果返回的消息数量小于请求的数量，说明没有更多消息了
          if (response.length < 10) {
            this.hasMore = false
          } else {
            this.hasMore = true
          }
          
          // 渲染完后滚动到底部
          this.$nextTick(() => {
            this.scrollToBottom()
          })
        } else {
          // 如果没有消息，清空列表
          this.messages = []
          this.hasMore = false
        }
      } catch (error) {
        console.error('获取消息列表失败:', error)
        // 出错时不清空消息列表，保持当前状态
      }
    },
    // 滚动到底部
    scrollToBottom() {
      if (this.$refs.messageList) {
        this.$refs.messageList.scrollTop = this.$refs.messageList.scrollHeight
      }
    },
    // 处理滚动事件
    handleScroll(event) {
      const element = event.target
      // 当滚动到顶部时（距离顶部小于50px），加载更多消息
      if (element.scrollTop <= 50 && !this.loadingMore && this.hasMore) {
        this.loadMoreMessages()
      }
    },
    // 加载更多历史消息
    async loadMoreMessages() {
      if (this.loadingMore || !this.hasMore || this.messages.length === 0) {
        return
      }

      // 获取第一条消息的 msgId
      const firstMessage = this.messages[0]
      if (!firstMessage || !firstMessage.msgId) {
        // 如果第一条消息没有 msgId，说明可能是旧数据格式，尝试从原始数据获取
        // 这里需要根据实际数据结构调整
        console.warn('无法获取第一条消息的 msgId')
        return
      }

      this.loadingMore = true

      try {
        // 记录当前滚动位置和高度
        const messageList = this.$refs.messageList
        const oldScrollHeight = messageList ? messageList.scrollHeight : 0
        const oldScrollTop = messageList ? messageList.scrollTop : 0

        // 获取第一条消息的 msgId
        const firstMsgId = firstMessage.msgId || ''

        const response = await request2('post', '/chat/getMessageList', {
          tempId: this.tempId,
          msgId: firstMsgId.toString(),
          size: 10
        })

        if (response && Array.isArray(response) && response.length > 0) {
          // 将新消息转换为组件需要的格式
          const newMessages = []
          response.forEach((msg) => {
            if (!msg) return

            const messageType = msg.sender === 1 ? 'sent' : 'received'
            let messageContent = msg.content || ''

            // 处理文件消息
            if (msg.msgType === 3) {
              let info = msg.info || ''
              if (typeof info === 'string' && info.startsWith('{')) {
                try {
                  info = JSON.parse(info)
                  info.url = msg.content
                } catch (e) {
                  console.error('解析文件消息失败:', e)
                }
              }
              messageContent = info
            }

            newMessages.push({
              type: messageType,
              msgType: msg.msgType || 1,
              content: messageContent,
              sender: msg.sender || 1,
              time: msg.createTime,
              msgId: msg.msgId // 保存 msgId 用于下次加载
            })
          })

          // 将新消息插入到数组前面
          this.messages.unshift(...newMessages)

          // 如果返回的消息数量小于请求的数量，说明没有更多消息了
          if (response.length < 10) {
            this.hasMore = false
          }

          // 保持滚动位置（新内容插入后，滚动位置需要调整）
          this.$nextTick(() => {
            if (messageList) {
              const newScrollHeight = messageList.scrollHeight
              const scrollDiff = newScrollHeight - oldScrollHeight
              // 保持原来的滚动位置，加上新增内容的高度
              messageList.scrollTop = oldScrollTop + scrollDiff
            }
          })
        } else {
          // 没有更多消息了
          this.hasMore = false
        }
      } catch (error) {
        console.error('加载更多消息失败:', error)
      } finally {
        this.loadingMore = false
      }
    },
    // 弹窗关闭时的处理（不断开连接）
    handleDialogClose() {
      // 关闭弹窗时不断开连接，只是隐藏弹窗
      // WebSocket 连接保持，直到页面关闭（mixin 中的 beforeDestroy 负责关闭）
    },
    // 添加消息（支持文本 / 图片 / 文件）
    // payload 可以是字符串（纯文本），也可以是包含 msgType、fileName、fileSize 等字段的对象
    addMessage(payload, type = 'sent') {
      const now = new Date()
      let time = `${now
        .getHours()
        .toString()
        .padStart(2, '0')}:${now
        .getMinutes()
        .toString()
        .padStart(2, '0')}`

      const baseMsg = {
        type,
        msgType: 1,
        content: '',
        sender: 1,
      }
      if (payload && typeof payload === 'object') {
        if (payload.createTime) {
          time = payload.createTime
        }
        baseMsg.sender = payload.sender || 1
        
        const msgType = payload.msgType || 1
        let content = payload.content ||''
        
        // 如果是文件消息（msgType=3）
        if (msgType === 3) {
          // content 可能是对象或 JSON 字符串（兼容从服务器接收的情况）
          if (typeof content === 'string' && content.startsWith('{')) {
            // content 是 JSON 字符串，需要解析（兼容旧格式或服务器返回）
            try {
              content = JSON.parse(content)
            } catch (e) {
              console.error('解析文件消息 JSON 失败:', e)
            }
          }
        }
        
        Object.assign(baseMsg, {
          msgType: msgType,
          content: content
        })
        
        // 如果 payload 中有 msgId，保存它
        if (payload.msgId) {
          baseMsg.msgId = payload.msgId
        }
      }

      baseMsg.time = time
      this.messages.push(baseMsg)

      // 滚动到底部
      this.$nextTick(() => {
        this.scrollToBottom()
      })
    },
    // 生成随机 UUID v4（浏览器环境）
    uuidv4() {
      if (window.crypto && window.crypto.getRandomValues) {
        // 标准 UUID v4 模板
        const template = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
        return template.replace(/[xy]/g, (c) => {
          const r = window.crypto.getRandomValues(new Uint8Array(1))[0] & 15
          const v = c === 'x' ? r : (r & 0x3) | 0x8
          return v.toString(16)
        })
      }
      // 兼容不支持 crypto 的老环境，退化为时间戳+随机数
      return (
        Date.now().toString(16) +
        '-' +
        Math.random().toString(16).substr(2, 12)
      )
    },
    async hmacSign(message, secret) {
        const encoder = new TextEncoder();
        const key = await crypto.subtle.importKey(
                'raw', encoder.encode(secret),
                {name:'HMAC',hash:'SHA-256'}, false, ['sign']);
        const sig = await crypto.subtle.sign('HMAC', key, encoder.encode(message));
        return btoa(String.fromCharCode(...new Uint8Array(sig)))
                .replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,''); // base64url
    },
    // 生成随机 code（4位）
    generateCode() {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
      let code = ''
      for (let i = 0; i < 4; i++) {
        code += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      return code
    },
    // 格式化时间为 "YYYY-MM-DD HH:mm:ss"
    formatDateTime(date = new Date()) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    // 发送文本消息
    sendMessage() {
      if (!this.inputMessage.trim()) {
        return
      }

      const message = this.inputMessage.trim()
      this.addMessage(
        {
          sender: 1,
          msgType: 1,
          content: message
        },
        'sent'
      )

      // 发送到服务器
      if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
        const msg = {
          event: 'TALK',
          content: {
            msgType: 1, // 文本
            sender: 1, // 1-用户，2-系统，3-客服
            senderId: this.tempId,
            content: message,
            code: this.generateCode(),
            createTime: this.formatDateTime()
          }
        }
        console.log("发送消息", msg);
        this.send(JSON.stringify(msg))
      } else {
        this.$message.warning('连接未建立，请稍候再试')
      }

      this.inputMessage = ''
      
      // 设置等待回复状态
      this.waitingForReply = true
    },
    // 发送图片或文件消息
    sendFileMessage(fileUrl, msgType, fileName = '', fileSize = 0) {
      // msgType: 2-图片, 3-文件
      if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
        let fileInfo = ''
        if (msgType === 3) {
          // 文件消息：content 转为 JSON 字符串发送
          fileInfo = {
            name: fileName,
            size: fileSize
          }
          fileInfo = JSON.stringify(fileInfo)
        }
        
        const msg = {
          event: 'TALK',
          content: {
            msgType: msgType,
            sender: 1, // 1-用户，2-系统，3-客服
            senderId: this.tempId,
            content: fileUrl,
            info: fileInfo,
            code: this.generateCode(),
            createTime: this.formatDateTime()
          }
        }
        this.send(JSON.stringify(msg))
        // 设置等待回复状态
        this.waitingForReply = true
      } else {
        this.$message.warning('连接未建立，请稍候再试')
      }
    },
    // 处理内容区域点击（关闭表情选择器）
    handleContentClick() {
      if (this.showEmojiPicker) {
        this.showEmojiPicker = false
      }
    },
    // 切换表情选择器
    toggleEmojiPicker() {
      this.showEmojiPicker = !this.showEmojiPicker
    },
    // 插入表情
    insertEmoji(emoji) {
      this.inputMessage += emoji
      this.showEmojiPicker = false
    },
    // 触发文件选择
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    // 处理文件选择
    async handleFileSelect(event) {
      const files = event.target.files
      if (files && files.length > 0) {
        // 处理选中的文件
        for (let i = 0; i < files.length; i++) {
          const file = files[i]
          // 判断是图片还是文件
          const isImage = file.type.startsWith('image/')
          const msgType = isImage ? 2 : 3
          
          // 上传文件并获取地址
          try {
            const fileUrl = await this.uploadFile(file)
            if (fileUrl) {
              // 发送消息（传递文件大小）
              this.sendFileMessage(fileUrl, msgType, file.name, file.size)
              // 在消息列表中显示（结构与 WebSocket 发送的消息保持一致）
              let content = ''
              if (isImage) {
                // 图片消息：content 为图片链接
                content = fileUrl
              } else {
                // 文件消息：content 为对象
                content = {
                  url: fileUrl,
                  name: file.name,
                  size: file.size
                }
              }
              this.addMessage(
                {
                  msgType,
                  sender: 1,
                  content: content
                },
                'sent'
              )
            }
          } catch (error) {
            console.error('文件上传失败:', error)
            this.$message.error(`文件上传失败: ${file.name}`)
          }
        }
      }
      // 清空文件选择，以便可以重复选择同一文件
      event.target.value = ''
    },
    // 处理粘贴事件（图片）
    async handlePaste(event) {
      // 检查是否有剪贴板数据
      if (!event.clipboardData || !event.clipboardData.items) {
        return
      }

      const items = event.clipboardData.items
      for (let i = 0; i < items.length; i++) {
        const item = items[i]
        // 检查是否是图片类型
        if (item.type && item.type.indexOf('image') !== -1) {
          event.preventDefault()
          event.stopPropagation()
          
          const file = item.getAsFile()
          if (file) {
            try {
              // 显示上传提示
              const loadingMessage = this.$message({
                message: '正在上传图片...',
                type: 'info',
                duration: 0
              })

              // 上传图片并获取地址
              const fileUrl = await this.uploadFile(file)
              
              // 关闭上传提示
              loadingMessage.close()

              if (fileUrl) {
                // 发送消息（图片消息，content 为图片链接）
                this.sendFileMessage(fileUrl, 2, '', 0)
                // 在消息列表中显示
                this.addMessage(
                  {
                    msgType: 2,
                    sender: 1,
                    content: fileUrl
                  },
                  'sent'
                )
              }
            } catch (error) {
              console.error('图片上传失败:', error)
              this.$message.error('图片上传失败，请稍后重试')
            }
          }
          break
        }
      }
    },
    // 上传文件到服务器
    // 接口文档见：src/文件上传.md
    // 注意：文件上传使用 FormData，request2 可能不支持，需要特殊处理
    async uploadFile(file) {
      const formData = new FormData()
      formData.append('file', file)

      // 文件上传需要使用 FormData，request2 可能不支持，保留使用 fetch
      // 如果需要使用 request2，可能需要修改 request2 以支持 FormData
      // 开发环境使用代理，生产环境使用完整 URL
      const uploadUrl = process.env.NODE_ENV === 'development' 
        ? '/webBackend/upload' 
        : 'https://scan.turingene.com/webBackend/upload'

      try {
        const response = await fetch(uploadUrl, {
          method: 'POST',
          headers: {
            // 其余头由浏览器自动补充，不能在这里显式设置 Content-Type 为 multipart/form-data
            tempId: this.tempId || ''
          },
          body: formData
        })

        if (!response.ok) {
          throw new Error(`上传接口返回错误状态码：${response.status}`)
        }

        // 文档示例返回的是一个字符串（文件 URL）
        const resultText = await response.text()
        const url = (resultText || '').replace(/^"(.*)"$/, '$1') // 去掉可能的引号

        if (!url) {
          throw new Error('上传接口返回为空')
        }

        return url
      } catch (error) {
        console.error('文件上传接口调用失败:', error)
        this.$message && this.$message.error('文件上传失败，请稍后重试')
        throw error
      }
    },
    // 格式化文件大小
    formatFileSize(size) {
      if (!size || isNaN(size)) return ''
      if (size < 1024) return `${size}B`
      const kb = size / 1024
      if (kb < 1024) return `${kb.toFixed(1)}KB`
      const mb = kb / 1024
      return `${mb.toFixed(2)}MB`
    },
    // 解析 Markdown 格式
    parseMarkdown(content) {
      if (!content || typeof content !== 'string') {
        return ''
      }
      try {
        // 配置 marked 选项
        marked.setOptions({
          breaks: true, // 支持 GitHub 风格的换行
          gfm: true // 启用 GitHub Flavored Markdown
        })
        return marked.parse(content)
      } catch (e) {
        console.error('Markdown 解析失败:', e)
        // 解析失败时返回转义后的原始内容
        return content.replace(/</g, '&lt;').replace(/>/g, '&gt;')
      }
    },
    // 处理流式消息
    handleStreamingMessage(result) {
      const { content, last, seq } = result
      const msgId = content.msgId
      
      if (!msgId) {
        console.warn('流式消息缺少 msgId，无法处理')
        return
      }
      
      // 获取或创建流式消息缓存
      if (!this.streamingMessages.has(msgId)) {
        this.streamingMessages.set(msgId, {
          chunks: new Map(), // 存储 seq -> content 的映射
          metadata: {
            sender: content.sender,
            msgType: content.msgType,
            createTime: content.createTime,
            senderId: content.senderId,
            msgId: msgId // 保存 msgId
          },
          lastSeq: -1, // 记录已收到的最大 seq
          messageIndex: -1 // 在 messages 数组中的索引，用于更新消息
        })
      }
      
      const streamData = this.streamingMessages.get(msgId)
      const chunkContent = content.content || ''
      
      // 存储当前片段（按 seq 存储）
      streamData.chunks.set(seq, chunkContent)
      
      // 更新最大 seq
      if (seq > streamData.lastSeq) {
        streamData.lastSeq = seq
      }
      
      // 拼接所有已收到的片段（按 seq 顺序）
      const sortedSeqs = Array.from(streamData.chunks.keys()).sort((a, b) => a - b)
      let fullContent = ''
      for (const s of sortedSeqs) {
        fullContent += streamData.chunks.get(s)
      }
      
      // 检查内容是否为空（文本消息需要检查，文件消息不需要）
      const isEmpty = streamData.metadata.msgType === 1 
        ? !fullContent || fullContent.trim() === '' 
        : false
      
      // 如果是最后一个片段且内容为空，直接清理缓存，不创建消息
      if (last === true && isEmpty) {
        this.streamingMessages.delete(msgId)
        return
      }
      
      // 如果内容为空但不是最后一个片段，跳过创建/更新，等待后续片段
      if (isEmpty && !last) {
        return
      }
      
      // 如果是第一次收到该消息，创建消息项
      if (streamData.messageIndex === -1) {
        // 根据消息类型处理内容
        let messageContent = fullContent
        
        if (streamData.metadata.msgType === 3) {
          // 文件消息：content 可能是对象或 JSON 字符串，统一转换为对象
          if (typeof messageContent === 'string' && messageContent.startsWith('{')) {
            try {
              messageContent = JSON.parse(messageContent)
            } catch (e) {
              console.error('解析文件消息失败:', e)
            }
          }
        }
        
        this.addMessage(
          {
            sender: streamData.metadata.sender,
            msgType: streamData.metadata.msgType,
            content: messageContent,
            createTime: streamData.metadata.createTime,
            msgId: streamData.metadata.msgId // 保存 msgId
          },
          'received'
        )
        
        // 收到客服或系统回复，清除等待状态
        if (streamData.metadata.sender === 2 || streamData.metadata.sender === 3) {
          this.waitingForReply = false
        }
        
        // 记录消息在数组中的索引（最后一条）
        streamData.messageIndex = this.messages.length - 1
      } else {
        // 更新已存在的消息内容
        const message = this.messages[streamData.messageIndex]
        if (message) {
          // 根据消息类型处理内容
          let messageContent = fullContent
          
          if (streamData.metadata.msgType === 3) {
            // 文件消息：content 可能是对象或 JSON 字符串，统一转换为对象
            if (typeof messageContent === 'string' && messageContent.startsWith('{')) {
              try {
                messageContent = JSON.parse(messageContent)
              } catch (e) {
                console.error('解析文件消息失败:', e)
              }
            }
          }
          
          message.content = messageContent
          
          // 触发视图更新
          this.$forceUpdate()
        }
      }
      
      // 如果是最后一个片段，清理缓存
      if (last === true) {
        this.streamingMessages.delete(msgId)
      }
    }
  },
  beforeDestroy() {
    // 页面关闭时断开 WebSocket 连接
    this.globalData.isHide = true
    // 其余关闭逻辑由 mixin 中的 beforeDestroy 处理
  }
}
</script>

<style scoped>
/* 遮罩层 */
.consult-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000;
}

/* PC 端默认弹窗样式 */
.consult-dialog {
  background: #fff;
  width: 600px;
  max-width: 90%;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
}

.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #7b9d38 0%, #5a7a2a 100%);
  padding: 15px 20px;
}

.dialog-title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;
  font-size: 18px;
  font-weight: 600;
}

.dialog-title i {
  font-size: 20px;
}

.dialog-close {
  cursor: pointer;
  color: #fff;
  font-size: 22px;
  line-height: 1;
}

.dialog-close:hover {
  color: #f0f0f0;
}

.consult-content {
  display: flex;
  flex-direction: column;
  height: 500px;
}

.message-list {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
}

.loading-more {
  text-align: center;
  padding: 10px;
  color: #999;
  font-size: 12px;
}

.message-item {
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
}

.message-item.sent {
  align-items: flex-end;
}

.message-item.received {
  align-items: flex-start;
}

.message-bubble {
  max-width: 70%;
  padding: 10px;
  border-radius: 12px;
  word-wrap: break-word;
  line-height: 1.5;
}

/* Markdown 消息样式 */
.message-text {
  word-wrap: break-word;
  line-height: 1.5;
}

.message-text ::v-deep h1,
.message-text ::v-deep h2,
.message-text ::v-deep h3,
.message-text ::v-deep h4,
.message-text ::v-deep h5,
.message-text ::v-deep h6 {
  margin: 10px 0 8px 0;
  font-weight: 600;
  line-height: 1.25;
}

.message-text ::v-deep h1 {
  font-size: 1.5em;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 5px;
}

.message-text ::v-deep h2 {
  font-size: 1.3em;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 5px;
}

.message-text ::v-deep h3 {
  font-size: 1.1em;
}

.message-text ::v-deep p {
  margin: 0;
}

.message-text ::v-deep ul,
.message-text ::v-deep ol {
  margin: 8px 0;
  padding-left: 25px;
}

.message-text ::v-deep li {
  margin: 4px 0;
}

.message-text ::v-deep code {
  background-color: rgba(0, 0, 0, 0.05);
  padding: 2px 6px;
  border-radius: 3px;
  font-family: 'Courier New', monospace;
  font-size: 0.9em;
}

.message-text ::v-deep pre {
  background-color: rgba(0, 0, 0, 0.05);
  padding: 10px;
  border-radius: 5px;
  overflow-x: auto;
  margin: 10px 0;
}

.message-text ::v-deep pre code {
  background-color: transparent;
  padding: 0;
}

.message-text ::v-deep blockquote {
  border-left: 4px solid rgba(0, 0, 0, 0.2);
  padding-left: 15px;
  margin: 10px 0;
  color: rgba(0, 0, 0, 0.7);
}

.message-text ::v-deep a {
  color: #409eff;
  text-decoration: none;
}

.message-text ::v-deep a:hover {
  text-decoration: underline;
}

.message-text ::v-deep table {
  border-collapse: collapse;
  margin: 10px 0;
  width: 100%;
}

.message-text ::v-deep th,
.message-text ::v-deep td {
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 6px 10px;
  text-align: left;
}

.message-text ::v-deep th {
  background-color: rgba(0, 0, 0, 0.05);
  font-weight: 600;
}

.message-text ::v-deep hr {
  border: none;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  margin: 15px 0;
}

.message-text ::v-deep img {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
  margin: 10px 0;
}

/* 发送的消息中的 markdown 样式（白色文字） */
.message-item.sent .message-text ::v-deep {
  color: white;
}

.message-item.sent .message-text ::v-deep h1,
.message-item.sent .message-text ::v-deep h2 {
  border-bottom-color: rgba(255, 255, 255, 0.3);
}

.message-item.sent .message-text ::v-deep code {
  background-color: rgba(255, 255, 255, 0.2);
}

.message-item.sent .message-text ::v-deep pre {
  background-color: rgba(255, 255, 255, 0.2);
}

.message-item.sent .message-text ::v-deep blockquote {
  border-left-color: rgba(255, 255, 255, 0.5);
  color: rgba(255, 255, 255, 0.9);
}

.message-item.sent .message-text ::v-deep a {
  color: #a0d8ff;
}

.message-item.sent .message-text ::v-deep th {
  background-color: rgba(255, 255, 255, 0.2);
}

.message-item.sent .message-text ::v-deep th,
.message-item.sent .message-text ::v-deep td {
  border-color: rgba(255, 255, 255, 0.3);
}

.message-item.sent .message-text ::v-deep hr {
  border-top-color: rgba(255, 255, 255, 0.3);
}

.message-image {
  max-width: 240px;
  max-height: 180px;
  border-radius: 6px;
  display: block;
}

.message-item.sent .message-bubble {
  background: #ADCB72;
  color: white;
  border-bottom-right-radius: 4px;
}

.message-item.received .message-bubble {
  background: #EFF3F6;
  color: #333;
  border-bottom-left-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* 等待回复动画 */
.typing-indicator {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 12px 16px;
  min-width: 50px;
}

.typing-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #7b9d38;
  animation: typing 1.4s infinite ease-in-out;
}

.typing-dot:nth-child(1) {
  animation-delay: 0s;
}

.typing-dot:nth-child(2) {
  animation-delay: 0.2s;
}

.typing-dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes typing {
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.7;
  }
  30% {
    transform: translateY(-10px);
    opacity: 1;
  }
}

.message-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 5px;
  padding: 0 5px;
}

.message-sender,
.message-time {
  font-size: 12px;
  color: #999;
}

/* 文件消息卡片样式 */
.file-card {
  width: 260px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  border: 1px solid #ebeef5;
}

.message-item.sent .file-card {
  background: #f5f7fa;
}

.file-card-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.file-name {
  font-size: 14px;
  color: #303133;
  max-width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-size {
  font-size: 12px;
  color: #909399;
}

.file-card-footer {
  font-size: 12px;
  color: #409eff;
  cursor: default;
}

.file-status {
  text-decoration: none;
}

.input-area {
  display: flex;
  flex-direction: column;
  position: relative;
}

.input-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}

.toolbar-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  color: #606266;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s;
  font-size: 18px;
}


.toolbar-btn:hover {
  background: #e4e7ed;
  color: #409eff;
}

.toolbar-btn:active {
  background: #d3d4d6;
}

.emoji-picker-container {
  position: absolute;
  bottom: 100%;
  left: 0;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  z-index: 3001;
  margin-bottom: 8px;
  max-width: 300px;
}

.emoji-picker {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-height: 200px;
  overflow-y: auto;
  padding: 8px;
}

.emoji-item {
  font-size: 24px;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background 0.2s;
  user-select: none;
}

.emoji-item:hover {
  background: #f0f0f0;
}

.emoji-item:active {
  background: #e0e0e0;
}

/* 去掉 el-input 边框（textarea） */
::v-deep .el-textarea__inner {
  border: none;
  box-shadow: none;
  resize: none;
}

.input-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
  padding: 0 15px;
}

.input-footer .tip {
  font-size: 12px;
  color: #999;
}

.send-btn {
  min-width: 70px;
  padding: 6px 14px;
  border-radius: 4px;
  border: none;
  background: #7b9d38;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.2s;
}

.send-btn:hover:enabled {
  background: #95b854;
}

.send-btn:disabled {
  background: #c0c4cc;
  cursor: not-allowed;
}

/* PC 端：发送按钮靠右浮动 */
@media only screen and (min-width: 769px) {
  .input-footer {
    justify-content: flex-start;
  }

  .input-footer .tip {
    margin-right: auto;
  }

  .send-btn {
    margin-left: 16px;
  }
}

/* 响应式：移动端与 PC 端样式不同 */
@media only screen and (max-width: 768px) {
  .consult-overlay {
    align-items: flex-end;
  }

  .consult-dialog {
    width: 100%;
    max-width: 100%;
    border-radius: 12px 12px 0 0;
    margin: 0;
  }

  .consult-content {
    height: 70vh;
  }

  /* 仅 PC 端显示提示，移动端隐藏 */
  .input-footer .tip {
    display: none;
  }
}
</style>

<style>
/* 提升 Element UI 消息提示层级，确保在咨询弹窗（z-index:3000）之上 */
.el-message {
  z-index: 4000 !important;
}
</style>
